import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import UploadField from '@/contactUs/views/UploadField';
import Input from '@/common/components/nikeforms/Input';
import { makeField } from 'nike-form-js';

const FormUploadField = ({ form, path, slot }) => {
    const { derefSub } = useReframe();
    const config = derefSub(['documentsUpload.ready']);
    const uploaded = derefSub(['documentsUpload.hasFilesUploaded', slot]) || false;
    const version = derefSub(['documentsUpload.slot.version', slot]);
    const slotConfig = config?.get(slot);
    const field = makeField(form, path);

    useEffect(() => {
        if (slotConfig) {
            const selectedDocument = slotConfig.get('documents')?.get(0);
            dispatch(['documentsUpload.selectDocument', slot, selectedDocument]);
        }
    }, [slot, slotConfig]);

    useEffect(() => {
        if (uploaded) {
            field.setValue(version);
        } else {
            field.resetValue();
        }
    }, [field, uploaded, version]);

    if (!slotConfig) {
        return null;
    }

    return (
        <>
            <Input type="hidden" form={form} path={path} />
            <UploadField config={slotConfig} slot={slot} />
        </>
    );
};

export default FormUploadField;
